import React from 'react';
import { Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { FileActionMenuItem } from '../FolderView/FileActionMenuItems';

type FileActionMenuProps = {
  ariaLabel?: string;
  icon: JSX.Element;
  items: FileActionMenuItem[];
  handleActionClick: (action: string) => void;
};

const FileActionMenu = ({
  icon,
  items,
  handleActionClick,
  ariaLabel = 'more options',
}: FileActionMenuProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onActionClick = (action: string) => {
    setAnchorEl(null);
    handleActionClick(action);
  };

  return (
    <>
      <IconButton aria-label={ariaLabel} color="primary" onClick={handleClick}>
        {icon}
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {
          items.map(({ icon, text, hasDivider, action }, index) => (
            [
              <MenuItem
                key={`${action}-${index}`}
                data-testid={`file-action-${action}-${index}`}
                onClick={() => onActionClick(action)}
              >
                <ListItemIcon>
                  {icon}
                </ListItemIcon>
                <ListItemText>{text}</ListItemText>
              </MenuItem>,
              hasDivider && <Divider />
            ]
          ))
        }
      </Menu>
    </>
  )
}

export default FileActionMenu;
